module.exports = __webpack_public_path__ + "media/images/lb/916-dae182166855523ab2b53e6ae0c6576b.svg";